module.exports = __webpack_public_path__ + "img/Canary Islands.25731acf.svg";